import JsonLd from "@/components/base/JsonLd";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackTop from "@/components/feature/BackTop";
import { usePageMeta } from "@/hooks/usePageMeta";
import { site } from "@/mocks/content";
import Hero from "./sections/Hero";
import CategoryBoards from "./sections/CategoryBoards";
import ExclusiveZone from "./sections/ExclusiveZone";
import TabFeed from "./sections/TabFeed";
import TrendingGrid from "./sections/TrendingGrid";
import AboutBand from "./sections/AboutBand";
import SubscribeBand from "./sections/SubscribeBand";

const schemaWebSite = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: site.name,
  alternateName: "今日新瓜独家内幕爆料",
  description: site.desc,
  inLanguage: "zh-CN",
  publisher: {
    "@type": "Organization",
    name: site.name,
    email: site.email,
  },
};

export default function Home() {
  usePageMeta(
    "今日新瓜 - 独家内幕与爆料，追瓜吃瓜第一站",
    "今日新瓜专注文娱独家内幕、独家爆料与独家栏目，深挖明星动态、综艺现场与圈内热点背后不为人知的内幕真相，独家详情持续放送。",
  );
  return (
    <>
      <JsonLd data={schemaWebSite} />
      <Navbar />
      <main>
        <Hero />
        <CategoryBoards />
        <ExclusiveZone />
        <TabFeed />
        <TrendingGrid />
        <AboutBand />
        <SubscribeBand />
      </main>
      <Footer />
      <BackTop />
    </>
  );
}